import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Divider,
  Card,
  Fab,
} from "@material-ui/core";
import CountriesTable from "./CountriesTable";
import { usePageStyles } from "../../pageStyles";
import { SearchBox } from "../../components/common/SearchBox";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import AddIcon from "@material-ui/icons/Add";
import { useCountrySearch } from "../../../data/listing/countries/hooks/useCountrySearch";
import { useHistory } from "react-router-dom";
import { PageTitle } from "../../components/common/PageTitle";
import { getCountryEditLocation } from "./Locations";

const CountriesPage: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  const [search, setSearch] = useCountrySearch();
  const history = useHistory();

  return (
    <Grid container className={pageStyles.root}>
      <Grid item xs={12} className={pageStyles.gridItem}>
        <Card>
          <CardHeader
            title={<PageTitle title="navCountries" />}
            action={<SearchBox search={search} setSearch={setSearch} />}
          />
          <Divider />
          <CardContent>
            <CountriesTable userAccessRights={userAccessRights} />
          </CardContent>
        </Card>
        {userAccessRights === AccessRights.All && (
          <Fab
            color="secondary"
            aria-label="add"
            className={pageStyles.mainFab}
            onClick={() => history.push(getCountryEditLocation())}
          >
            <AddIcon />
          </Fab>
        )}
      </Grid>
    </Grid>
  );
};

export default CountriesPage;
